import { CurrentUser } from '../../../model/Common/common.interface'
import useMapTagToWording from '../../../modules/hooks/webview/caf/common/useMapTagToWording'
import { n_lesson_prep } from '../../../modules/i18n/strings/auto/wording'
import { n_caf } from '../../../modules/i18n/strings/auto/wording_webview'
import useTranslation from '../../../modules/i18n/useTranslation'
import { COLORS } from '../../../modules/vars'

export interface RecommendHighlight {
  tag: number
}

interface LessonPreparationCafBodyProps {
  currentUser: CurrentUser
  data: any
}

const StudySectionContainer = ({ dataList }) => {
  const { namePerTag, iconPerTag } = useMapTagToWording()
  const { t } = useTranslation()
  return (
    <div className="flex-start flex-col space-y-8">
      {dataList &&
        dataList.map((highItem, index) => {
          const Icon = iconPerTag(highItem.highlight_tag)
          const Name = namePerTag(highItem.highlight_tag)
          const Detail = t(n_caf.highlight[`category${highItem.highlight_tag}`])

          return (
            <div className="flex-start flex rounded-[8px] bg-blue-50 py-12 px-16 font-bold" key={index}>
              <Icon
                width={18}
                height={18}
                className="mr-[2px] [&>*]:fill-current"
                color={COLORS.BLACK}
                fill={COLORS.BLACK}
              />
              <div className="line-height-160 text-[14px]">
                {Name} - {Detail}
              </div>
            </div>
          )
        })}
    </div>
  )
}

const LessonPreparationCafBody = ({ currentUser, data }: LessonPreparationCafBodyProps) => {
  const username = currentUser.profile.name ? currentUser.profile.name : null
  const { t } = useTranslation()

  return (
    <div className="flex-start flex-col space-y-12">
      {data.is_pinned ? (
        <>
          <div className="text-[18px] font-bold">{t(n_lesson_prep.overview.study_category3(username))}</div>{' '}
          {/** no wording */}
          <StudySectionContainer dataList={data.tags} />
        </>
      ) : (
        <>
          <div className="text-[18px] font-bold">{t(n_lesson_prep.overview.study_category2(username))}</div>
          <StudySectionContainer dataList={data.tags} />
        </>
      )}
    </div>
  )
}

export default LessonPreparationCafBody
